import { useSsrDocMetadataQuery } from 'js/file_viewer/core/queries/riviera_preview_types/ssr_doc';
export const useSsrDocPageDimensions = (previewKey, previewMetadata) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = useSsrDocMetadataQuery(previewKey, previewMetadata)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.apiData.metadata) === null || _c === void 0 ? void 0 : _c.dimensions;
};
export const usePageCount = (previewKey, previewMetadata) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = useSsrDocMetadataQuery(previewKey, previewMetadata)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.apiData.metadata) === null || _c === void 0 ? void 0 : _c.pageCount;
};
export const useIsPasswordProtected = (previewKey, previewMetadata) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = useSsrDocMetadataQuery(previewKey, previewMetadata)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.apiData.metadata) === null || _c === void 0 ? void 0 : _c.isPasswordProtected;
};
//# sourceMappingURL=ssr_doc.preenvesnextjs.map
